import firebaseUtil from '../data/FirebaseUtil';
import app from '../authentication/firebaseStart'
import { SSO_CONSTANTS } from '../data/constants';
export const logoutSSOUser = async (SSOSettings, validateSSO = false) => {

    if (SSOSettings.ssoProvider === SSO_CONSTANTS.SSO_PROVIDERS.AZURE) {
        if (!validateSSO) {
            return firebaseUtil.revokeTokenAccess().then(() => {
                return constructLogoutUrl(SSOSettings)
            }).catch((err) => {
                console.log("Error in revokeTokenAccess", err);
                return err;
            })
        }
    }
    if (SSOSettings.clientAuthType === SSO_CONSTANTS.CLIENT_AUTH_TYPE.NONE) {
        return firebaseUtil.revokeTokenWithSSOServer().then((res) => {
            console.log("SSO detail log logout revoke sso token success", res)
            if (!validateSSO) {
                return firebaseUtil.revokeTokenAccess().then(() => {
                    return constructLogoutUrl(SSOSettings)
                }).catch((err) => {
                    console.log("Error in revokeTokenAccess", err);
                    return err;
                })
            }
        }).catch((err) => {
            console.log("SSO detail log logout revoke sso token error", err);
            return err;
        })
    } else {
        //for TLS,PCKE and others
        if (!validateSSO) {
            return firebaseUtil.ssoSessionLogout().then(() => {
                return firebaseUtil.revokeTokenAccess().then(() => {
                    return constructLogoutUrl(SSOSettings)
                }).catch((err) => {
                    console.log("Revoke access Token Error: " + err);
                    return err;
                })
            }).catch((err) => {
                console.log("SSO Session Log Out Error: " + err);
                return err
            })
        } else {
            return Promise.resolve();
        }
    }
}

const constructLogoutUrl = (SSOSettings) => {
    localStorage.setItem("urlBasedSSOLogout","true")
    if (SSOSettings.ssoProvider === SSO_CONSTANTS.SSO_PROVIDERS.PING_FRED && SSOSettings.clientAuthType === SSO_CONSTANTS.CLIENT_AUTH_TYPE.NONE) {
        console.log("SSOSettings.logoutURL == ", `${SSOSettings.logoutURL}?TargetResource=${SSOSettings.webRedirectURI}&InErrorResource=${SSOSettings.webRedirectURI}`)
        window.location = `${SSOSettings.logoutURL}?TargetResource=${SSOSettings.webRedirectURI}&InErrorResource=${SSOSettings.webRedirectURI}`;
    }
    if (SSOSettings.ssoProvider === SSO_CONSTANTS.SSO_PROVIDERS.AZURE) {
        console.log("SSOSettings.logoutURL == ", `${SSOSettings.logoutURL}?post_logout_redirect_uri=${SSOSettings.webRedirectURI}`)
        window.location = `${SSOSettings.logoutURL}?post_logout_redirect_uri=${SSOSettings.webRedirectURI}`;
    }
}